import { Box } from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import BrightnessBar from "../common/brightness-bar";

const BrightnessNumber1Widget = ({
  widget,
  onValueUpdate,
  isEditing = false,
}) => {
  const [brightness, setBrightness] = useState(0);
  const [w1, setW1] = useState({});
  const [minMax, setMinMax] = useState({ min: 0, max: 100 });
  const sliderRef = React.useRef(null);
  const lastValueRef = useRef(null);

  useEffect(() => {
    if (widget) {
      const initialValue = Number(widget.value);
      setMinMax({
        min: widget.min ?? 0,
        max: widget.max ?? 100,
      });
      setBrightness(initialValue);
      lastValueRef.current = initialValue;
    }
    return () => {};
  }, [widget]);

  const handleValueUpdate = (data) => {
    if (data === lastValueRef.current) return;
    const updatedWidget = {
      ...widget,
      value: data,
    };
    lastValueRef.current = data;
    onValueUpdate(updatedWidget);
  };

  const handleBrightnessChange = (event, newValue) => {
    event.stopPropagation();
    const adjustedValue = Math.min(Math.max(newValue, minMax.min), minMax.max);
    setBrightness(adjustedValue);
  };

  return (
    <Box sx={{ height: "100%", width: "100%", position: "relative" }}>
      {w1 && (
        <BrightnessBar
          value={brightness}
          onChange={handleBrightnessChange}
          onValueUpdate={handleValueUpdate}
          disabled={isEditing}
          min={minMax.min}
          max={minMax.max}
          sliderRef={sliderRef}
        />
      )}
    </Box>
  );
};

export default BrightnessNumber1Widget;
